import React from 'react';
import MainTop from './MainTop';
import MainBody from './MainBody';
import { useSelector } from 'react-redux';

function Main() {

	const objectives = useSelector(state => state.objectives);

	const departments = [{ 'name': 'Operations', 'slug': 'operations', 'description': 'Proving that our manufacturing process works', 'color': "#6300d6" },
	{ 'name': 'Products', 'slug': 'products', 'description': 'Proving that we have an attractive product', 'color': "#1000d6" },
	{ 'name': 'Sales', 'slug': 'sales', 'description': 'Proving that we can sell and deliver our products', 'color': "#005bd6" },
	{ 'name': 'Bus dev', 'slug': 'business-development', 'description': 'Proving that we have opportunities for scale', 'color': "#00a5d6" },
	{ 'name': 'Finance', 'slug': 'finance', 'description': 'Making sure we have enough money to get it all done', 'color': "#00d6bd" }];

	return (
		<section className="main-container">
			<MainTop objectives={objectives} departments={departments} />
			<MainBody objectives={departments} />
			<div className="container">
				<div className="category-outer">
					<div className="row">
						<div className="col-sm-12 col-lg-3 align-center status-symbols">
							<ul>
								<li>Status</li>
								<li class="status-scheduled">Scheduled</li>
								<li class="status-progress">In progress</li>
								<li class="status-hold">On hold</li>
								<li class="status-completed">Completed</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Main;